import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FormattedMessage, useIntl } from "react-intl";
import { ValidateFiveDigitCode } from "../../utils/Helpers/PostalCodeValidator";

const ZipChip = ({ postcode, loading, onZipChange }) => {
     const intl = useIntl();
     const [editing, setEditing] = useState(false);
     const [draft, setDraft] = useState(postcode || "");

     useEffect(() => {
          setDraft(postcode || "");
     }, [postcode]);

     if (editing) {
          return (
               <div className="toolbar-zip-chip toolbar-zip-chip--editing">
                    <svg
                         width="13"
                         height="13"
                         viewBox="0 0 24 24"
                         fill="none"
                         stroke="currentColor"
                         strokeWidth="2.5"
                         strokeLinecap="round"
                         strokeLinejoin="round"
                         aria-hidden="true">
                         <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                         <circle cx="12" cy="10" r="3" />
                    </svg>
                    <input
                         className="toolbar-zip-input"
                         type="text"
                         inputMode="numeric"
                         autoComplete="off"
                         maxLength={5}
                         value={draft}
                         autoFocus
                         onChange={(e) => setDraft(e.target.value.replace(/\D/g, "").slice(0, 5))}
                         onKeyDown={(e) => {
                              if (e.key === "Enter" && ValidateFiveDigitCode(draft)) {
                                   setEditing(false);
                                   onZipChange(draft);
                              } else if (e.key === "Escape") {
                                   setDraft(postcode || "");
                                   setEditing(false);
                              }
                         }}
                         onBlur={() => {
                              setDraft(postcode || "");
                              setEditing(false);
                         }}
                    />
               </div>
          );
     }

     return (
          <button
               type="button"
               className="toolbar-zip-chip"
               disabled={loading}
               aria-label={intl.formatMessage(
                    {
                         id: "incentives.zipAriaLabel",
                         defaultMessage: "Showing incentives for {postcode}. Click to change ZIP."
                    },
                    { postcode }
               )}
               onClick={() => setEditing(true)}>
               <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
               </svg>
               <span>
                    <FormattedMessage
                         id="incentives.forZip"
                         defaultMessage="For {postcode}"
                         values={{ postcode: <span className="postcode-text">{postcode}</span> }}
                    />
               </span>
               <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#22c55e"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-label={intl.formatMessage({
                         id: "incentives.zipValidPostalCode",
                         defaultMessage: "Valid ZIP code"
                    })}
                    style={{ flexShrink: 0 }}>
                    <polyline points="20 6 9 17 4 12" />
               </svg>
          </button>
     );
};

ZipChip.propTypes = {
     postcode: PropTypes.string,
     loading: PropTypes.bool,
     onZipChange: PropTypes.func
};

export default ZipChip;
